import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import WriterComposer from '@/components/partials/ProductTabs/WriterComposer/WriterComposerContainer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';
import { IWriterComposer } from '@/data/models/track';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'trackData'
  | 'baseMixedTrack'
  | 'handleWriterComposer'
  | 'areNewMultipleTracks'
  | 'isMultipleTrack'
  | 'fieldHasErrors'
  | 'fieldValidationState'
> &
  BaseFormGroupProps;

export default function TrackWriterComposerFormGroup({
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  handleWriterComposer,
  areNewMultipleTracks,
  isMultipleTrack,
  fieldHasErrors,
  fieldValidationState,
}: Props) {
  const { t } = useTranslation();

  const writersComposers = !isMultipleTrack
    ? trackData.writersComposers ?? []
    : baseMixedTrack?.writersComposers?.value;

  const hasWritersComposersIssue =
    !isMultipleTrack && fieldHasErrors('WritersComposers');
  const validationState = !isMultipleTrack
    ? fieldValidationState?.('WritersComposers')
    : undefined;
  const hasInvalidWritersComposers =
    !writersComposers ||
    writersComposers.length === 0 ||
    writersComposers.some((wc: any) => {
      const wcData = wc?.value !== undefined ? wc.value : wc;
      return !wcData || !wcData.name || !wcData.role;
    });
  const hasErrors =
    hasWritersComposersIssue && !readonly && hasInvalidWritersComposers;

  return (
    <>
      {!readonly ? (
        <FormGroupWithTooltip
          tooltipKey="tooltip.track.lyricistComposer"
          hasErrors={hasErrors}
        >
          <label htmlFor="writerComposerName-0" className="col-sm-3 form-label">
            {t('track.writerComposer')}
          </label>
          <div className="col-sm-6 product-composer">
            <WriterComposer
              errorBanner={hasErrors}
              writerComposer={writersComposers}
              originalWriterComposer={
                baseMixedTrack?.writersComposers?.originalValue
              }
              handleWriterComposer={handleWriterComposer}
              readonly={readonly}
              disabled={disabled}
              validationState={validationState}
              multiTrack={isMultipleTrack}
              showChangeIndicator={!areNewMultipleTracks}
            />
          </div>
        </FormGroupWithTooltip>
      ) : (
        <ReadOnlyField
          id={'writerComposer'}
          labelTitle={t('track.writerComposer')}
          mode={'objectValueTypeList'}
          value={(writersComposers as IWriterComposer[])?.map((a) => ({
            name: a.name,
            role: a.role,
          }))}
        ></ReadOnlyField>
      )}
    </>
  );
}
